import {Component, Inject, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VenueListingItem } from '../../models/listing';
import { Banner } from '../../models/banner-model';
import { Category } from '../../models/category';
import { New } from '../../models/new';
import { HelperService } from '../../Services/helper.service';
import { SeoMetaService } from '../../Services/seo-meta.service';
import { TranslationService } from "../../Services/translation.service";
import {CITY} from "../../tokens";


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  city: String;
  lastNews: New[];
  categories: Category[];
  homeBanners: Banner[];
  recommendedBanners: any;
  homeSelectedForYou: VenueListingItem[];
  homeLastAdded: VenueListingItem[];
  lastActions: any;
  word: any;
  language: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private helperService: HelperService,
    private meta: SeoMetaService,
    private translationService: TranslationService,
    @Inject(CITY) private injectedCity: string,
  ) {
    this.city = this.injectedCity || this.helperService.getCity();
    this.language = this.translationService.language;
    this.word = this.translationService.word;
// new seo service
    this.meta.generateTags({
      title:  this.word[this.language].seoTitle1 + (this.language == 'bg' ? (this.city == 'varna' ? ' във ' : ' в ') : this.language != 'en' ? '' : 'in' ) + this.word[this.language][`${this.city}`] + " | " + this.word[this.language].zavedeniaBG,
      description: this.word[this.language].seoDescriptionOg,
      keywords: this.word[this.language].seoKeywords1 + this.word[this.language][`${this.city}`] + this.word[this.language].seoKeywords2 ,
      image: '/assets/images/zav-ph.png',
    })
    // this.meta.updateUrl(this.language);
    this.meta.updateLinks(this.language, `https://${this.city}.zavedenia.com`);
  }

  ngOnInit(): void {
    this.city = this.injectedCity || this.helperService.getCity();
    this.language = this.translationService.language;
    this.word = this.translationService.word;

    this.activatedRoute.data.subscribe((data) => {
      // home banners
      this.homeBanners = data.homeBanners;
      // home blog
      this.lastNews = data.lastNews;
      // home categories
      this.categories = data.categories;
      // home recommended
      this.recommendedBanners = data.recommendedBanners;
      // home selected for you
      this.homeSelectedForYou = data.homeSelectedForYou;
      //home last added
      this.homeLastAdded = data.homeLastAdded;
      // home last activities
      this.lastActions = data.lastActions;

    });
  }
}
